import React from 'react'
export const FALLBACK_PLACEHOLDER =
  'data:image/svg+xml,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="600" viewBox="0 0 400 600"><defs><linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:#e0e7ff"/><stop offset="50%" style="stop-color:#c7d2fe"/><stop offset="100%" style="stop-color:#a5b4fc"/></linearGradient></defs><rect width="400" height="600" fill="url(#g)"/><text x="200" y="280" text-anchor="middle" font-family="system-ui,sans-serif" font-size="48" fill="#6366f1">📚</text><text x="200" y="330" text-anchor="middle" font-family="system-ui,sans-serif" font-size="14" fill="#818cf8">Image unavailable</text></svg>',
  )
export const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
  const target = e.currentTarget
  if (target.src !== FALLBACK_PLACEHOLDER) {
    target.src = FALLBACK_PLACEHOLDER
    target.style.objectFit = 'cover'
  }
}
export const spiceLevelMap: Record<
  number,
  {
    label: string
    bg: string
    text: string
    iconColor: string
    darkBg: string
    darkText: string
  }
> = {
  1: {
    label: 'Mild',
    bg: 'bg-sky-50',
    text: 'text-sky-700',
    iconColor: 'text-sky-500',
    darkBg: 'bg-sky-900/30',
    darkText: 'text-sky-300',
  },
  2: {
    label: 'Warm',
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    iconColor: 'text-amber-500',
    darkBg: 'bg-amber-900/30',
    darkText: 'text-amber-300',
  },
  3: {
    label: 'Spicy',
    bg: 'bg-orange-50',
    text: 'text-orange-700',
    iconColor: 'text-orange-500',
    darkBg: 'bg-orange-900/30',
    darkText: 'text-orange-300',
  },
  4: {
    label: 'Extra Hot',
    bg: 'bg-rose-50',
    text: 'text-rose-700',
    iconColor: 'text-rose-500',
    darkBg: 'bg-rose-900/30',
    darkText: 'text-rose-300',
  },
  5: {
    label: 'Inferno',
    bg: 'bg-red-50',
    text: 'text-red-700',
    iconColor: 'text-red-500',
    darkBg: 'bg-red-900/30',
    darkText: 'text-red-300',
  },
}
export const darknessLevelMap: Record<
  number,
  {
    label: string
    bg: string
    text: string
    iconColor: string
    darkBg: string
    darkText: string
  }
> = {
  1: {
    label: 'Shadow',
    bg: 'bg-slate-100',
    text: 'text-slate-600',
    iconColor: 'text-slate-400',
    darkBg: 'bg-slate-800',
    darkText: 'text-slate-300',
  },
  2: {
    label: 'Grey',
    bg: 'bg-slate-100',
    text: 'text-slate-700',
    iconColor: 'text-slate-500',
    darkBg: 'bg-slate-800',
    darkText: 'text-slate-300',
  },
  3: {
    label: 'Abyss',
    bg: 'bg-gray-200',
    text: 'text-gray-800',
    iconColor: 'text-gray-600',
    darkBg: 'bg-gray-700',
    darkText: 'text-gray-200',
  },
  4: {
    label: 'Pitch Black',
    bg: 'bg-gray-800',
    text: 'text-gray-100',
    iconColor: 'text-gray-300',
    darkBg: 'bg-gray-900',
    darkText: 'text-gray-100',
  },
  5: {
    label: 'The Void',
    bg: 'bg-gray-900',
    text: 'text-white',
    iconColor: 'text-gray-400',
    darkBg: 'bg-black',
    darkText: 'text-gray-300',
  },
}
